<template>
  <div v-if="faq" class="delivery-faq-wrapper">
    <section class="faq" data-assetkey="faq">
      <div v-if="heading" class="faq__heading">
        <h2>{{ heading }}</h2>
      </div>

      <div v-if="intro" class="faq__paragraph" v-html="intro"></div>

      <div class="faq__lines">
        <details v-for="(item, index) in faq || []" :key="index" v-if="item.faq_question && item.faq_answer">
          <summary class="h5">
            <span>
              <h3 class="expandable-list-heading">{{ item.faq_question }}</h3>
              <span class="expandable-list-toggle"></span>
            </span>
          </summary>
          <section class="expandable-list-content" v-html="item.faq_answer"></section>
        </details>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  data() {
    return{
      heading: "",
      intro: "",
      faq: [],
    }
  },
  beforeMount() {
    this.heading = window.global_theme_object?.delivery_faq.heading;
    this.intro = window.global_theme_object?.delivery_faq.intro;
    this.faq = window.global_theme_object?.delivery_faq.faq;

    if(window.product_faq.length){
      this.faq = this.faq.concat(window.product_faq);
    }
  }
};
</script>
